import React, { FC } from 'react'
import { HStack } from '@chakra-ui/react'
import styled from '@emotion/styled'

import { BasicComponentProps } from '../../common/types'

type CardProps = {
  bgImage: string
  title: string
}

const Text = styled.p`
  display: flex;
  align-items: flex-end;
  background: linear-gradient(
    110.72deg,
    #737373 15.77%,
    rgba(201, 201, 201, 0.860937) 30.52%,
    rgba(185, 185, 185, 0.66) 54.06%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
`

const Card: FC<BasicComponentProps<CardProps>> = ({
  bgImage,
  title,
  ...rest
}) => {
  return (
    <HStack
      w={430}
      h={260}
      align='flex-end'
      p={5}
      pl={8}
      bg={`url(${bgImage}) center/cover no-repeat,  linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 56.25%, #131415 99%)`}
      bgBlendMode='darken'
      filter='drop-shadow(5px 7px 20px rgba(0, 0, 0, 0.45))'
      borderRadius={23}
      cursor='pointer'
      {...rest}
    >
      <Text>{title}</Text>
    </HStack>
  )
}

export default Card
